/**
 * `RichText` — render a message body with auto-linked URLs + markdown-lite (bold/italic/code) +
 * line breaks (widget side). Uses the shared XSS-safe tokenizer; every token is a React node
 * (text escaped by React, http/https links only), so a message body can never inject HTML.
 */

import { Fragment } from 'react';
import { tokenizeMessage } from '@flozic/shared';

export function RichText({ body }: { body: string | null | undefined }) {
  const tokens = tokenizeMessage(body);
  return (
    <>
      {tokens.map((t, i) => {
        switch (t.kind) {
          case 'br':
            return <br key={i} />;
          case 'link':
            return (
              <a
                key={i}
                href={t.href}
                target="_blank"
                rel="noreferrer noopener"
                className="underline underline-offset-2"
              >
                {t.value}
              </a>
            );
          case 'bold':
            return <strong key={i} className="font-semibold">{t.value}</strong>;
          case 'italic':
            return <em key={i}>{t.value}</em>;
          case 'code':
            return (
              <code key={i} className="rounded bg-black/10 px-1 py-0.5 font-mono text-[0.85em]">
                {t.value}
              </code>
            );
          default:
            return <Fragment key={i}>{t.value}</Fragment>;
        }
      })}
    </>
  );
}

export default RichText;
